export default {
  button: {
    toMainPage: "Bosh sahifa",
    login: "Kirish",
    registration: "Ro‘yxatdan o‘tish",
    back: "Orqaga",
    rcGroupWiki: "RC Group Wiki",
  },
  title: "Avtorizatsiya",
  pageTab: {
    owner: "Ega",
    manager: "Menejer",
  },
  form: {
    country: "Mamlakat",
    mail: "Pochta",
    login: "Login",
    password: "Parol",
    repeatPass: "Parolni takrorlang",
    minInputSize: "Kamida {size} ta belgi bo‘lishi kerak",
  },
  noAccount: "Hisobingiz yo‘qmi?",
  forgotPassword: "Parolni unutdingizmi?",
  dontWorryAboutForgotPass:
    "Xavotir olmang, sizga pochta orqali tiklash havolasini yuboramiz",

  resetPass: {
    dontWorry:
      "Xavotir olmang, sizga pochta orqali tiklash havolasini yuboramiz",
    info: {
      title: "Kirish ma’lumoti emailingizga yuborildi",
      sendedLink: "Parolni o‘zgartirish havolasini emailingizga yubordik",
      checkSpam: "Agar xatni olmagan bo‘lsangiz, «Spam» papkasini tekshiring",
    },
    resendMail: "Xatni qayta yuborish 00:%{timer} dan keyin",
    messageNotReceived: "Xat kelmadimi?",
    title: "Parolni o‘zgartirish",
    enterNewPass:
      "Shaxsiy kabinetga kirishda foydalanadigan yangi parolni kiriting",
  },
  enterNewPassword: "Yangi parolni kiriting",
  oldLink: "Havola eskirgan",
  failMailCheck: "Email tekshirishda xatolik",
};
